import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Feedback.module.css';
import * as utils from '../../utils/utils';

export default class Feedback extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			feedbackText: '',
			isSending: false,
			successText: '',
			errorText: '',
		};
	};

	onFeedbackChange = (value) => {
		this.setState({
			feedbackText: value,
			successText: '',
			errorText: '',
		});
	};

	onSaveFeedback = async () => {
		const feedbackText = this.state.feedbackText.trim();

		if (this.state.isSending) {
			return;
		}

		if (feedbackText === '') {
			this.setState({ errorText: 'Please enter your feedback before sending.' });
			return;
		}

		this.setState({
			isSending: true,
			successText: '',
			errorText: '',
		});

		try {
			await utils.sendRequest('/feedback/saveFeedback', {
				feedbackText,
			});

			this.setState({
				feedbackText: '',
				successText: 'Feedback sent. Thanks for sharing it.',
			});
		} catch (error) {
			this.setState({
				errorText: error?.message || 'Could not send feedback right now.',
			});
		} finally {
			this.setState({
				isSending: false,
			});
		}
	};

	render() {
		const { feedbackText, isSending, successText, errorText } = this.state;

		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowLayer}>
					<div className={styles.glowTop} />
					<div className={styles.glowBottom} />
				</div>

				<div className={styles.layoutShell}>
					<section className={styles.cardPanel}>
						<div className={styles.sectionHeader}>
							<h2 className={styles.formTitle}>
								<FiMessageSquare /> Share Feedback
							</h2>
							<p className={styles.formText}>
								Tell us what is working, what is missing, or what would make your experience better.
							</p>
						</div>

						<div className={styles.contentSection}>
							<div className={styles.inputWrapper}>
								<label className={styles.inputLabel} htmlFor="feedback-text">
									Your Feedback
								</label>
								<textarea
									id="feedback-text"
									value={feedbackText}
									onChange={(event) => this.onFeedbackChange(event.target.value)}
									className={styles.textarea}
									placeholder="Write your feedback here..."
									rows={8}
								/>
							</div>

							{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
							{successText !== '' && <div className={styles.successBox}>{successText}</div>}

							<button
								type="button"
								className={styles.primaryButton}
								onClick={this.onSaveFeedback}
								disabled={isSending}
							>
								{isSending ? 'Sending...' : 'Send Feedback'}
							</button>
						</div>
					</section>
				</div>
			</div>
		);
	};
}
